<script setup>
// core
import {ref} from "vue";
import useActivationViberTelephony from "@/components/activation/api/useActivationViberTelephony";

// components
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

// assets
import QrImg from "@/assets/avans-activation/avans-qr.png";
import store from "../../store/store";

const emit = defineEmits(["nextStep"])

const isInitiateLoading = ref(false)
const {initiateActivationViberTelephony, activationStatusNumber} = useActivationViberTelephony()


const onClick = async () => {
    isInitiateLoading.value = true
    try {
        const code = await store.dispatch('auth/getCodeCountry')
        const country = code === 'UA' ? code : 'EU'
        await initiateActivationViberTelephony({
            country
        })
        emit('nextStep', activationStatusNumber.value)
    } finally {
        isInitiateLoading.value = false
    }
}
</script>

<template>
    <div>
        <HeaderMain>{{ $t('telephony.activation.mainheader') }}</HeaderMain>

        <div class="activation__block">
            <img :src="QrImg" class="img1" alt="QrImg"/>
            <div class="activation__start">
                <p class="activation__text">
                    {{ $t('telephony.activation.lead') }}
                </p>
                <ul>
                    <li v-for="(step, i) in $tm('telephony.activation.steps')" :key="i">
                        {{ step }}
                    </li>
                </ul>
                <ButtonLoading class="ec_button" :loading="isInitiateLoading" @click="onClick">
                    {{ $t("page.activation.button") }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.activation {
    &__start {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    &__block {
        margin-top: 30px;
        padding: 23px 48px;

        width: 100%;
        border-radius: 11px;
        background: var(--block-color);
        display: flex;
        align-items: center;
        gap: 52px;

        box-sizing: border-box;
    }

    &__text {
        color: var(--text-second-color);
        font-family: 'Gilroy', sans-serif;
        font-size: 24px;
        font-weight: 700;
        line-height: 170%;
        padding: 0 20px 0 0;
        text-transform: none;
    }

    ul {
        list-style: none;

        li {
            position: relative;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 28px;
            color: var(--text-third-color);
            margin: 10px 0;
            padding-left: 25px;

            &::before {
                content: url("@/assets/intlTel/check.svg");
                position: absolute;
                left: 0;
                top: 10px;
                transform: translateY(-50%);
                width: 10px;
                height: 10px;
            }
        }
    }

    @media screen and (max-width: 680px) {
        .activation__block {
            flex-direction: column;
            padding: 15px;
        }

        .activation__text {
            font-size: 14px;
            line-height: 150%;
        }
        .activation__start {
            padding: 0;

            ul li {
                font-size: 12px;
                line-height: 150%;

                &::before {
                    top: 5px;
                }
            }

            .ec_button {
                width: 100%;
            }
        }
        .img1 {
            width: 220px;
            margin: 0;
        }
    }
}
</style>
